import React from 'react';
import Pagination from './Pagination';
import { useSelector, useDispatch } from 'react-redux';
import { SET_GROUP_PAGINATION, SET_PAGINATION, SET_SERVICE_PAGINATION } from '../../redux/ActionName/ActionName';

function ServicePagination() {
    const dispatch = useDispatch();
    const ServicePaginationReducer = useSelector((state) => state.ServicePaginationReducer);


    console.log("ServicePaginationReducer",ServicePaginationReducer);
    



    // Extract pagination data from reducer
    const { page, limit, total } = ServicePaginationReducer.pagination;

    // Handle page change
    const handlePageChange = (newPage) => {
        dispatch({
            type: SET_SERVICE_PAGINATION,
            value: {
                ...ServicePaginationReducer.pagination,
                page: newPage
            }
        });
    };

    return (
        <div className="flex justify-center py-5">
            <Pagination
                total={total}
                outline={true}
                defaultCurrent={1}
                current={page}
                onChange={handlePageChange}
                pageSize={limit}
            />
        </div>
    );
}

export default ServicePagination;
